import { Alert, Snackbar } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNotifications } from './notify';

export function Notifier() {
  const { t } = useTranslation(['errors', 'common']);
  const { current, dismiss } = useNotifications();
  return (
    <Snackbar
      key={current?.id}
      open={!!current}
      autoHideDuration={current?.severity === 'error' ? 8000 : 4000}
      onClose={(_, reason) => reason !== 'clickaway' && dismiss()}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      {current ? (
        <Alert severity={current.severity} variant="filled" onClose={dismiss} sx={{ minWidth: 320 }}>
          {t(current.message, { defaultValue: t('errors:UNKNOWN') })}
          {current.requestId ? <small style={{ display: 'block', opacity: 0.8 }}>ID: {current.requestId}</small> : null}
        </Alert>
      ) : undefined}
    </Snackbar>
  );
}
